import axios from "axios"

function getPedagogicalObjectives({ studentId }) {
    return axios.get(`/api/students/${studentId}/pedagogical-objectives`)
}

function createPedagogicalObjective({ studentId }, data) {
    return axios.post(`/api/students/${studentId}/pedagogical-objectives`, data)
}

function deletePedagogicalObjective({ studentId, objectiveId }) {
    return axios.delete(`/api/students/${studentId}/pedagogical-objectives/${objectiveId}`)
}

function updatePedagogicalObjective({ studentId, objectiveId }, data) {
    return axios.patch(`/api/students/${studentId}/pedagogical-objectives/${objectiveId}`, data)
}

function updatePedagogicalObjectiveStatus({ studentId, objectiveId }, data) {
    return axios.put(`/api/students/${studentId}/pedagogical-objectives/${objectiveId}/status`, data)
}

function formulateObjectiveGoal({ studentId }, data) {
    // Admin endpoint: expects { type, subject_ids[], needs?, comment? }
    return axios.post(`/api/students/${studentId}/pedagogical-objectives/formulate`, data)
}

function updateObjectiveLiveSessions({ studentId, objectiveId }, data) {
    return axios.post(`/api/students/${studentId}/pedagogical-objectives/${objectiveId}/live-sessions`, data)
}

function updateObjectivesHourAllocation({ studentId }, data) {
    // Admin endpoint: expects { hours_${objectiveId}: newHours, ... }
    // Backend handles logic: if objective < 1 week old, update hours; else close and recreate
    return axios.post(`/api/students/${studentId}/pedagogical-objectives/update-hours`, data)
}

export const pedagogicalObjectivesService = {
    getPedagogicalObjectives,
    createPedagogicalObjective,
    deletePedagogicalObjective,
    updatePedagogicalObjective,
    updatePedagogicalObjectiveStatus,
    formulateObjectiveGoal,
    updateObjectiveLiveSessions,
    updateObjectivesHourAllocation,
}
